// extracted by mini-css-extract-plugin
export default {"root":"button_root__9bOuy"};